@if(ptgFeatureComparisonData) {
  <table class="feature-comparison-table">
    <thead>
      <tr>
        <th class="left-align"></th>
        <th *ngFor="let header of columnHeaders; let colIdx = index" class="center-align">
          <div class="flexContainer">
            <div class="cert-image"
                matTooltip="Dieser Produkttyp wurde von einer unabhängigen Stelle zertifiziert."
                [matTooltipPosition]="'above'"
                *ngIf="certifiedColumns[colIdx]"
                [ngStyle]="{ 'background-image': 'url(/assets/svg-icons/certification.svg)' }">
            </div>
            <div *ngIf="doesVariantFulfillAllFeaturesOfPTGVersion(colIdx)"
              class="centerGridItem"
              matTooltip="Gemäß Anbieter erfüllt dieses Produkt alle Funktionen die für den Anwendungsbereich (Produkttyp) verpflichtend notwendig sind."
              [matTooltipPosition]="'above'"
              style="position: relative;">
              <mat-icon class="greenIcon">check</mat-icon>
              <!-- <mat-icon class="greenIcon sec-check-icon">check</mat-icon> -->
            </div>
          </div>
        </th>
      </tr>
      <tr>
        <th class="left-align"></th>
        <th *ngFor="let header of columnHeaders; let i = index" 
          [matTooltip]="overflowingHeaders[i] ? header : null"
          matTooltipPosition="above">
          <span class="table-header-text" #headerSpan>
            {{ header }}
          </span>
        </th>
      </tr>
    </thead>
    <tbody>
        <tr *ngFor="let row of featureRows" class="gridContainer2 table-border">
          <td class="left-align">
            <span>
              {{ row.featureName }}
            </span>
            <mat-icon 
            [matTooltip]="row.featureDescription"
            matTooltipPosition="above"
            class="info-tooltip-icon"
            tabindex="-1"
            >info_outline</mat-icon>
          </td>
          <td *ngFor="let value of row.values; let i = index; trackBy: trackByValue">
            <ng-container *ngIf="!isBooleanFeature(row); else booleanFeature">
              {{ value }}
            </ng-container>
            <ng-template #booleanFeature>
              <mat-icon *ngIf="value === 'true'" class="greenIcon">done</mat-icon>
              <mat-icon *ngIf="value === 'false'" class="grayIcon">close</mat-icon>
              <span *ngIf="value !== 'true' && value !== 'false'">–</span>
            </ng-template>
          </td>
        </tr>
    </tbody>
  </table>
}

@if (features) { 
    <div class="gridContainer table-border highlight-category">
        <div class="flexContainer">
            <div class="featureCategory">{{ title }}</div>
            <mat-icon
                class="info-tooltip-icon"
                color="primary"
                matTooltip="{{ tooltipText }}"
            >
                info_outline
            </mat-icon>
        </div>
    </div>
    <div *ngFor="let feature of features; trackBy: trackByFeature" class="gridContainer table-border">
        <div class="feature" #featureElement>
            {{ feature.featureName }}
        </div>
        <div>
            <div *ngIf="!isBooleanFeature(feature); else booleanFeature">
                {{ feature.featureValidation }}
            </div>
            <ng-template #booleanFeature [ngSwitch]="feature.featureValidation">
                <div *ngSwitchCase="'true'">
                    <mat-icon class="greenIcon">done</mat-icon>
                </div>
                <div *ngSwitchCase="'false'">
                    <mat-icon class="grayIcon">close</mat-icon>
                </div>
                <div *ngSwitchDefault class="grayIcon">
                    <svg height="24" viewBox="0 -960 960 960" width="24">
                        <path
                            fill="currentColor"
                            d="M424-320q0-81 14.5-116.5T500-514q41-36 62.5-62.5T584-637q0-41-27.5-68T480-732q-51 0-77.5 31T365-638l-103-44q21-64 77-111t141-47q105 0 161.5 58.5T698-641q0 50-21.5 85.5T609-475q-49 47-59.5 71.5T539-320H424Zm56 240q-33 0-56.5-23.5T400-160q0-33 23.5-56.5T480-240q33 0 56.5 23.5T560-160q0 33-23.5 56.5T480-80Z"
                        />
                    </svg>
                </div>
            </ng-template>
        </div>
        <div></div>
    </div>
}
